import React from 'react'
import Effortless from '../../../components/home/Effortless'
import Empower from '../../../components/newHome/Empower'
import Steps from '../../../components/newHome/Steps'
import WhyPK from '../../../components/newHome/WhyPK'
import Testimonials3 from '../../../components/newHome/Testimonials3'
import WhyWorkWith from '../../../components/newHome/WhyWorkWith'
import { howToData, whyWorkWithData } from '../../../utils/data/data'
import ActionBanner, { bannerData } from '../../../components/newHome/ActionBanner'
import NewHowTo from '../../../components/newHome/NewHowTo'

const WasteGenerators = () => {
  return (
    <div>
      <Empower/>
      {/* <Effortless/> */}
      {/* <WhyPK/> */}
      {/* <Steps/> */}
      <NewHowTo content={howToData[0].content}/>
      <WhyWorkWith content={whyWorkWithData[0].content}/>
      <Testimonials3/>
      <ActionBanner
        title={bannerData[0].title}
        desc={bannerData[0].desc}
        img={bannerData[0].img}
        children={bannerData[0].children}
      />
    </div>
  )
}

export default WasteGenerators